import React from "react";
import styles from "./index.module.css";

const Input = ({ id, label, key, required=false,isDisabled, ...inputArgs }) => {

    const handleChange = (event) => {
        event.target.value = event?.target?.value?.replaceAll(/\^/g, '')?.trimStart(); // removes spaces at start and end only
        // event.target.value = event?.target?.value?.replaceAll(/\^/g, '')?.trim();
        inputArgs?.onChange(event)
      };

    return (
        <div className={`${styles.formGroup} ${inputArgs?.formGroupClassOverride}`} style={inputArgs.formGroupStyleOverride } key={key}>
            {label&&<label style={inputArgs.labelStyleOverride} htmlFor={id}>{label} {required&&<span className="required">*</span>}</label>}
            <input
                maxLength={100}
                required={required}
                className={styles.input}
                style={inputArgs.inputStyleOverride}
                {...inputArgs}
                // pattern="[a-z]"
                // disabled={isDisabled}
                onChange={handleChange}

            />
        </div>
    );
};

export default React.memo(Input);
